
import { requestParalegal, requestCommon} from '../libs/axios'
export const getVipInfo = (params) => requestParalegal.post('/user/info', params) // 获取律师基本信息
export const getVip = (params) => requestParalegal.post('/vip/getVipInfoList', params) // 获取律师基本信息
export const getVipDetail = (params) => requestParalegal.post('/vip/getVipInfo', params) // 订单信息 
export const setVip = (params) => requestCommon.post('/order/vip/pay', params) // 订单信息
export const getBuyVip = (orderNo) => requestCommon.post(`/order/vip/query/${orderNo}` ) // 订单信息